import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { SlideAnimationProvider } from "contexts/SlideAnimation";
import { useContext, useEffect } from "react";
import { useLocation } from "react-router-dom";

import CreateTemplateDialog from "features/Influencer/HomePage/CreateTemplateDialog";
import { trackEvent } from "utils/tracking";

export default function CreateTemplate() {
  const location = useLocation();
  const { setCurrentTemplateBody } = useContext(OutreachTemplatesContext);

  useEffect(() => {
    trackEvent("Create Template Dialog Form - Opened", {
      route: location.pathname,
    });
    // Defensive: drop any leftover AI-assistant prefill body when the dialog
    // unmounts, so it can't leak into a later "Add Template" open. `finalClose`
    // already clears it on the happy path; this covers external close paths
    // (route changes, parent toggling `createTemplateDialogOpen`).
    return () => setCurrentTemplateBody(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <SlideAnimationProvider>
      <CreateTemplateDialog />
    </SlideAnimationProvider>
  );
}
